var ScaleRange = /** @class */ (function () {
    function ScaleRange() {
        this.id = null;
        this.rangeStart = 0;
        this.rangeEnd = 0;
        this.name = "";
        this.displayName = "";
        this.clientContent = "";
        this.therapistContent = "";
        // for now we go to video... if we change to anything
        // else we can handle it from this flag.
        this.mediaType = "video";
        this.mediaURL = null;
        this.assignmentURL = null;
    }
    Object.defineProperty(ScaleRange.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (v) {
            this._id = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleRange.prototype, "mediaType", {
        get: function () {
            return this._mediaType;
        },
        set: function (v) {
            this._mediaType = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleRange.prototype, "mediaURL", {
        get: function () {
            return this._mediaURL;
        },
        set: function (v) {
            this._mediaURL = v;
        },
        enumerable: true,
        configurable: true
    });
    ScaleRange.prototype.hasMedia = function () {
        return this._mediaType == 'video' && this._mediaURL;
    };
    Object.defineProperty(ScaleRange.prototype, "assignmentURL", {
        get: function () {
            return this._assignmentURL;
        },
        set: function (v) {
            this._assignmentURL = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleRange.prototype, "midPoint", {
        get: function () {
            var mid = this.rangeStart + Math.ceil(Math.abs(this.rangeEnd - this.rangeStart) / 2);
            return mid;
        },
        enumerable: true,
        configurable: true
    });
    ScaleRange.prototype.getPercentageForRange = function (score) {
        var minRange = this.rangeStart;
        var maxRange = this.rangeEnd;
        if (score < minRange || score > maxRange) {
            throw new Error("Score(" + score + ") is out of range(" + minRange + "," + maxRange + ")");
        }
        // we make it inclusive and start our scores off one based if the rangeStart is a 0
        // if (minRange > 0) {
        // 	// we are inclusive so we are adding one to the endInterval
        // 	maxRange += 1;
        // }
        var maxInterval = Math.max(maxRange - minRange, 1);
        var interval = score - minRange;
        var normalizedPercentage = 0;
        // NOTE: APSATS request, if the interval range is only 1, and a user scores a 0 value we want the graph to show in the middle
        // instead of at the very beginning of the range.
        if (maxInterval == 1) {
            normalizedPercentage = interval == 0 ? 50 : 100;
        }
        else {
            normalizedPercentage = Math.round((interval / maxInterval) * 100);
        }
        return normalizedPercentage;
    };
    Object.defineProperty(ScaleRange.prototype, "rangeStart", {
        get: function () {
            return this._rangeStart;
        },
        set: function (v) {
            this._rangeStart = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleRange.prototype, "rangeEnd", {
        get: function () {
            return this._rangeEnd;
        },
        set: function (v) {
            this._rangeEnd = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleRange.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (v) {
            this._name = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleRange.prototype, "displayName", {
        get: function () {
            return this._displayName;
        },
        set: function (v) {
            this._displayName = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleRange.prototype, "therapistContent", {
        get: function () {
            return this._content;
        },
        set: function (v) {
            this._content = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleRange.prototype, "clientContent", {
        get: function () {
            return this._clientContent;
        },
        set: function (value) {
            this._clientContent = value;
        },
        enumerable: true,
        configurable: true
    });
    return ScaleRange;
}());
export { ScaleRange };



// WEBPACK FOOTER //
// ./src/app/shared/models/scale-range.ts.pre-build-optimizer.js